import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { DialogService } from 'app/shared/ui/dialog/dialog.service';
import { ContactsService } from '../../store/services/contacts.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DialogButton } from 'app/store/models/dialog.model';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog, openSnackbar } from 'app/store/actions/page.action';
import { MatRadioChange } from '@angular/material/radio';
import { MatStepper } from '@angular/material/stepper';
import { IUserSessionData, UserState, UserType } from 'app/store/models/user.model';
import { EReducers } from '../../store/reducers';
import { updateLeftMenuCount } from 'app/store/actions/meeting.action';
import { DIALOG_COMPONENT, DialogComponent } from '../../shared/ui/dialog/dialog.component';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { TimezonePipe } from '../../shared/ui/pipes/timezone.pipe';
import { UtilitiesService } from '../../store/services/utilities.servive';
import { EXCLUDED_DOMAINS_FROM_MASS_INACTIVE } from '../../store/models/contact.model';
import {
  RemoveContactsFromDomainDialogComponent,
} from '../remove-contacts-from-domain-dialog/remove-contacts-from-domain-dialog.component';
import { InactiveAddContactComponent } from '../inactive-add-contact/inactive-add-contact.component';
import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { ISelectItem } from '../../store/models/select.model';
import { ButtonDisablerService } from '../../store/services/button-disabler.service';
import { EditorComponent } from 'app/shared/ui/editor/editor.component';

export class FileUploadModel {
  data: File;
  index: string;
  isValid: boolean;
}

@Component({
  selector: 'app-r-content',
  templateUrl: './r-content.component.html',
  styleUrls: ['./r-content.component.scss'],
})
export class RContentComponent implements OnInit, OnDestroy {
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('conversationEditor') conversationEditor: EditorComponent;
  fileAttr = 'Choose File';
  public data;
  public item;
  // tslint:disable-next-line:variable-name
  public contact_id;
  public replies;
  public products = [];
  public redirectRoute: string;
  public accountId?: number;
  messageId: number;
  attachments: any;
  userData: IUserSessionData;
  signature = '';
  startDate = new Date();
  formReady = false;
  initialSignature = '';
  subject = '';
  recipients = '';
  overrideRecipients: string;
  dataReady = false;
  modeUpdate = false;
  isLinear = true;
  editorConfig = {};
  editorReady: boolean;
  formGroup: FormGroup;
  /** File extension that accepted, same as 'accept' of <input type="file" />. By the default, it's set to 'image/*'. */
  accept: string | string[];
  allowMultiple: boolean;
  maxFiles: number;
  maxFileSize: string | number;
  extraParams: {
    [key: string]: any
  };
  /** Allow you to add handler after its completion. Bubble up response text from remote. */
  complete = new EventEmitter<any>();
  error = new EventEmitter<HttpErrorResponse>();
  showLoadingSpinner: boolean;
  files: Array<FileUploadModel> = [];
  inputForm: FormGroup;
  buttonColors = ButtonColor;
  componentReady = false;
  private timezonePipe: TimezonePipe;
  private hasSavedSignature = false;
  private inactiveDialogOpened: boolean;
  private stopCloseInactive: boolean;

  constructor(
    private dialogService: DialogService,
    private contactsService: ContactsService,
    private store: Store<IReducers>,
    private detectorRef: ChangeDetectorRef,
    @Inject(DIALOG_COMPONENT) private readonly dialogComponent: DialogComponent,
    private readonly utilService: UtilitiesService,
    private readonly router: Router,
    private readonly buttonDisabler: ButtonDisablerService,
  ) {
    this.timezonePipe = new TimezonePipe(this.utilService);
    this.store.select(EReducers.USER).subscribe((userState: UserState) => {
      if (userState.sessionData) {
        this.userData = userState.sessionData;
        this.signature = this.userData.signature;
        this.hasSavedSignature = true;
      }
    });

    this.dialogComponent.onClose().subscribe(() => {
      this.editorReady = false;
    });
  }

  get cc(): ISelectItem[] {
    if (!this.data.cc) {
      return [];
    }

    if (Array.isArray(this.data.cc)) {
      return this.data.cc.map(d => ({
        label: d,
        value: d,
      }));
    }

    if (this.data.cc.indexOf(',') !== -1) {
      return this.data.cc.split(',').map(c => ({
        label: c,
        value: c,
      }));
    } else if (this.data.cc.indexOf(';') !== -1) {
      return this.data.cc.split(';').map(c => ({
        label: c,
        value: c,
      }));
    }

    return [{
      label: this.data.cc,
      value: this.data.cc,
    }];
  }

  myFilter = (d: Date | null): boolean => {
    // Prevent Saturday and Sunday from being selected.
    return d >= new Date();
  };

  getMaxFileSizeInBytes() {
    if (typeof this.maxFileSize === 'number') {
      return this.maxFileSize;
    }

    const base = 1024;
    let index = 1;
    for (const target of ['KB', 'MB', 'GB']) {
      if (this.maxFileSize.indexOf(target) !== -1) {
        const size = +this.maxFileSize.slice(
          0,
          this.maxFileSize.indexOf(target),
        );

        return size * Math.pow(base, index);
      }
      index++;
    }

    return 0;
  }

  isMaxFileSizeReached(file: File): boolean {
    if (this.maxFileSize) {
      return this.getMaxFileSizeInBytes() < file.size;
    }

    return false;
  }

  setDialogButtons() {
    const buttons: DialogButton[] = [];
    if (
      this.data.tag !== 'followup' &&
      this.data.tag !== 'cycle' &&
      this.data.tag !== 'order' &&
      this.data.tag !== 'custom_email_1' &&
      this.data.tag !== 'enter_activity'
    ) {
      if (this.data.tag !== 'conversation' && this.data.tag !== 'send-email') {
        buttons.push({
          text: 'Update',
          size: ButtonSize.NORMAL,
          color: ButtonColor.ORANGE,
          onClick: () => this.update(),
        });
      }
      buttons.push({
        text: 'Send',
        onClick: () => this.submit(),
        color: ButtonColor.BLUE,
        size: ButtonSize.NORMAL,
      });
    } else if (this.data.tag === 'custom_email_1') {
      buttons.push({
        text: 'Send',
        onClick: () => this.submit(),
        color: ButtonColor.BLUE,
        size: ButtonSize.NORMAL,
      });
    } else if (this.data.tag === 'order') {
      buttons.push({
        text: 'Save',
        onClick: () => this.submit(),
        color: ButtonColor.BLUE,
        size: ButtonSize.NORMAL,
      });
    } else if (this.data.tag === 'followup') {
      if (this.getSelected() === 0) {
        buttons.push({
          text: 'Update',
          size: ButtonSize.NORMAL,
          color: ButtonColor.ORANGE,
          onClick: () => this.initUpdate(),
        });
        buttons.push({
          text: 'Send',
          onClick: () => this.submitNext(),
          color: ButtonColor.BLUE,
          size: ButtonSize.NORMAL,
        });
      } else if (this.getSelected() > 0) {
        if (!this.formGroup.get('same_message').value) {
          buttons.push({
            text: this.getSelected() === 3 ? 'Ok' : 'Next',
            size: ButtonSize.NORMAL,
            color: ButtonColor.BLUE,
            onClick: () => this.updateNext(),
          });
        } else {
          buttons.push({
            text: 'Ok',
            size: ButtonSize.NORMAL,
            color: ButtonColor.BLUE,
            onClick: () => this.submitNext(),
          });
        }
      }
    } else if (this.data.tag === 'cycle') {
      if (this.getSelected() === 0) {
        buttons.push({
          text: 'Update',
          size: ButtonSize.NORMAL,
          color: ButtonColor.ORANGE,
          onClick: () => {
            this.modeUpdate = true;
            this.updateNext();
          },
        });
        buttons.push({
          text: 'Send',
          size: ButtonSize.NORMAL,
          color: ButtonColor.BLUE,
          onClick: () => this.submitNext(),
        });
      } else {
        buttons.push({
          text: 'Ok',
          size: ButtonSize.NORMAL,
          color: ButtonColor.BLUE,
          onClick: () => this.submitNext(),
        });
      }
    } else if (this.data.tag === 'enter_activity') {
      buttons.push({
        text: 'Save',
        size: ButtonSize.NORMAL,
        color: ButtonColor.BLUE,
        onClick: () => this.submitNext(),
      });
    }

    this.dialogComponent.setButtons(buttons);
  }

  getProductsItems() {
    return this.products.map(i => ({ label: i.product_name, value: i.id }));
  }

  ngOnInit() {
    if (
      this.data.tag !== 'conversation' &&
      this.data.tag !== 'send-email' &&
      this.data.tag !== 'custom_email_1' &&
      this.data.tag !== 'enter_activity'
    ) {
      this.contactsService
        .getTemplateReplies(this.data.tag, this.contact_id, this.accountId)
        .subscribe(response => {
          if (this.data.tag !== 'order') {
            this.initialSignature = response.replaced_content;
            if (this.data.tag === 'cycle') {
              this.initialSignature = this._replaceSignatureMonths('3');
            }
            this.subject = response.subject;
            if (this.data.tag === 'meeting') {
              this.recipients = response.recipients;
            }
          }

          this.contactsService.getReplies().subscribe(responseReplies => {
            this.replies = responseReplies.items;
            this.formGroup = new FormGroup({});

            const tag = this.data.tag;
            switch (tag) {
              case 'remove':
                this.formGroup.addControl('cc_to', new FormControl([]));
                break;
              case 'inactive':
                this.formGroup.addControl(
                  'action',
                  new FormControl('Not a good fit', Validators.required),
                );
                this.formGroup.addControl(
                  'custom_reason',
                  new FormControl(''),
                );

                if (this.data.cc) {
                  this.formGroup.addControl('cc_to', new FormControl([]));
                }
                break;
              case 'conversation':
                this.formGroup.addControl(
                  'to',
                  new FormControl(this.data.contact_email, Validators.required),
                );
                this.formGroup.addControl('cc_to', new FormControl(''));
                this.formGroup.addControl(
                  'subject',
                  new FormControl(this.subject, Validators.required),
                );
                this.formGroup.addControl(
                  'name',
                  new FormControl(this.fileAttr),
                );
                this.formGroup.addControl('attachments', new FormControl(''));
                break;
              case 'followup':
                this.formGroup.addControl(
                  'subject',
                  new FormControl(this.subject, Validators.required),
                );
                this.formGroup.addControl(
                  'action',
                  new FormControl('', Validators.required),
                );
                this.formGroup.addControl(
                  'future_message',
                  new FormControl(''),
                );
                this.formGroup.addControl(
                  'future_message_1',
                  new FormControl(''),
                );
                this.formGroup.addControl(
                  'future_message_2',
                  new FormControl(''),
                );
                this.formGroup.addControl(
                  'future_message_3',
                  new FormControl(''),
                );
                this.formGroup.addControl(
                  'same_message',
                  new FormControl(true),
                );

                this.formGroup.addControl(
                  'name',
                  new FormControl(this.fileAttr),
                );
                this.formGroup.addControl('attachments', new FormControl(''));

                this.formGroup.addControl('cc_to', new FormControl([]));
                break;
              case 'cycle':
                this.formGroup.addControl(
                  'subject',
                  new FormControl(this.subject, Validators.required),
                );
                this.formGroup.addControl('action', new FormControl('3'));
                this.formGroup.addControl(
                  'future_message',
                  new FormControl(''),
                );

                if (this.data.cc) {
                  this.formGroup.addControl('cc_to', new FormControl([]));
                }
                break;
              case 'order':
                this.contactsService
                  .getProducts()
                  .subscribe(responseProducts => {
                    this.formGroup.addControl('quote', new FormControl(''));
                    this.formGroup.addControl('action', new FormControl('', [Validators.required]));
                    this.formGroup.addControl(
                      'product_id',
                      new FormControl(''),
                    );
                    this.formGroup.addControl('amount', new FormControl(''));

                    this.products = responseProducts.items;

                    this.editorReady = true;
                    this.formReady = true;
                    this.dataReady = true;
                    this.setDialogButtons();
                  });
                break;
              case 'meeting':
                const nowTime = moment();
                const startTime = nowTime.clone();
                const curMinutes = nowTime.get('minutes');
                let setMinutes = 0;
                if (curMinutes > 15 && curMinutes < 30) {
                  setMinutes = 15;
                } else if (curMinutes >= 30 && curMinutes < 45) {
                  setMinutes = 30;
                } else if (curMinutes > 45) {
                  setMinutes = 45;
                }

                startTime.set({
                  minutes: setMinutes,
                });

                const nowPlusOneHour = moment().add(1, 'hour');
                let cc = this.recipients;

                if (this.overrideRecipients) {
                  cc = [this.recipients, this.overrideRecipients].join(',');
                }
                this.formGroup.addControl(
                  'cc_to',
                  new FormControl(cc),
                );
                this.formGroup.addControl(
                  'action',
                  new FormControl(this.startDate),
                );
                this.formGroup.addControl(
                  'start_time',
                  new FormControl(startTime),
                );
                this.formGroup.addControl(
                  'end_time',
                  new FormControl(nowPlusOneHour),
                );
                this.formGroup.addControl(
                  'location',
                  new FormControl('', Validators.required),
                );
                this.formGroup.addControl(
                  'subject',
                  new FormControl(this.subject),
                );
                this.onStartDateChange(null, true);
                break;
              default:
                break;
            }

            this.editorConfig = this.onPreInit(responseReplies.items);
            this.formGroup.addControl('message', new FormControl(this.initialSignature, this.data.tag === 'order' ? [] : [
              Validators.required,
            ]));
            if (this.data.tag !== 'order') {
              this.editorReady = true;
              this.formReady = true;
              this.dataReady = true;
              this.setDialogButtons();
            }
          });
        });
    } else {
      this.contactsService.getReplies().subscribe(response => {
        if (this.userData.signature && this.data.tag !== 'enter_activity') {
          this.initialSignature = '<p></p>' + this.userData.signature;
        }

        this.replies = response.items;
        this.editorConfig = this.onPreInit(response.items);
        this.editorReady = true;
        this.formGroup = new FormGroup({
          message: new FormControl(this.initialSignature, [
            Validators.required,
          ]),
        });
        if (this.data.tag === 'conversation') {
          this.contactsService
            .getTemplateReplies(this.data.tag, this.contact_id, this.accountId)
            .subscribe(responseReplies => {
              this.subject = responseReplies.subject;
              this.recipients = responseReplies.recipients;
              this.formGroup.addControl(
                'to',
                new FormControl(
                  {
                    value: this.recipients,
                    disabled: true,
                  },
                  Validators.required,
                ),
              );
              // this.formGroup.addControl('cc', new FormControl(''));
              this.formGroup.addControl(
                'subject',
                new FormControl(this.subject, Validators.required),
              );
              this.formGroup.addControl('name', new FormControl(this.fileAttr));
              this.formGroup.addControl('attachments', new FormControl(''));
              this.formGroup.addControl('cc_to', new FormControl([]));
              this.formReady = true;
              this.dataReady = true;
            });
        } else if (this.data.tag === 'custom_email_1') {
          this.subject = '';
          this.formGroup.addControl(
            'to',
            new FormControl(
              {
                value: this.data.contact_email,
                disabled: true,
              },
              Validators.required,
            ),
          );
          this.formGroup.addControl(
            'subject',
            new FormControl(this.subject, Validators.required),
          );
          this.formGroup.addControl('attachments', new FormControl(''));
          this.formGroup.addControl('name', new FormControl(this.fileAttr));
          this.formReady = true;
          this.dataReady = true;
        } else if (this.data.tag === 'enter_activity') {
          this.formGroup.addControl(
            'action',
            new FormControl('phone', [Validators.required]),
          );
          this.formGroup.addControl(
            'subject',
            new FormControl('', [Validators.required]),
          );
          this.formGroup.addControl(
            'message',
            new FormControl('', [Validators.required]),
          );
          this.formReady = true;
          this.dataReady = true;
        } else {
          let contactEmail = '';
          if (this.data.contact_email) {
            contactEmail = this.data.contact_email;
          } else if (this.item.contact_email) {
            contactEmail = this.item.contact_email;
          }

          this.formGroup.addControl(
            'to',
            new FormControl(contactEmail, Validators.required),
          );
          this.formGroup.addControl('cc_to', new FormControl(''));
          this.formGroup.addControl(
            'subject',
            new FormControl(this.subject, Validators.required),
          );
          this.formGroup.addControl('name', new FormControl(this.fileAttr));
          this.formGroup.addControl('attachments', new FormControl(''));
          this.formReady = true;
          this.dataReady = true;
        }
        this.setDialogButtons();
      });
    }
  }

  getSelected() {
    if (this.stepper !== undefined) {
      return this.stepper.selectedIndex;
    } else {
      return 0;
    }
  }

  getControl(name) {
    return this.formGroup.get(name);
  }

  modalClose() {
    this.dialogService.close();
  }

  openInactiveDialog() {
    if (this.userData && (this.userData.user_type !== UserType.SINGLE_USER && this.userData.user_type !== UserType.VSM)) {
      this.dialogComponent.closeDialog();
      this.componentReady = false;
      if (this.redirectRoute) {
        this.router.navigate([this.redirectRoute]);
      }
      return;
    }
    if (['meeting', 'followup', 'inactive', 'remove'].indexOf(this.data.tag) === -1) {
      this.dialogComponent.closeDialog();
      this.componentReady = false;
      if (this.redirectRoute) {
        this.router.navigate([this.redirectRoute]);
      }
      return;
    }

    let contactEmail = this.data.contact_email;

    if (!contactEmail) {
      contactEmail = this.item.contact_email;
    }

    if (!contactEmail) {
      this.dialogComponent.close();
      this.componentReady = false;
      if (this.redirectRoute) {
        this.router.navigate([this.redirectRoute]);
      }
      return;
    }

    const domain = contactEmail.split('@')[1];

    if (EXCLUDED_DOMAINS_FROM_MASS_INACTIVE.indexOf(domain) !== -1) {
      if (this.redirectRoute && !this.stopCloseInactive) {
        this.componentReady = false;
        this.dialogComponent.close();
        this.router.navigate([this.redirectRoute]);
      }

      if(this.stopCloseInactive) {
        this.showLoadingSpinner = false;
        this.stopCloseInactive = false;
        this.componentReady = true;
        this.buttonDisabler.unlockAll();
        this.buttonDisabler.disableActive();
      }
      return;
    }

    if (this.inactiveDialogOpened) {
      return;
    }
    this.inactiveDialogOpened = true;

    this.contactsService.getContacts(domain, this.userData.user_type === UserType.VSM ? this.accountId : null)
      .subscribe(data => {
        if (data && data.count && data.count > 1) {
          this.store.dispatch(openDialog({
            dialogData: {
              content: RemoveContactsFromDomainDialogComponent,
              componentData: {
                domain,
                userType: this.userData.user_type,
                accountId: this.accountId,
                contactId: this.contact_id,
              },
              dialogWidth: '900px',
              title: 'Remove Contacts from the same domain?',
              buttons: [],
              canClose: true,
              onClose: (dialog) => {
                this.inactiveDialogOpened = false;
                this.componentReady = false;
                if (this.redirectRoute) {
                  this.router.navigate([this.redirectRoute]);
                }
                this.dialogComponent.close();
              },
            },
          }));
          return;
        } else {
          this.dialogComponent.close();
          this.componentReady = false;
          if (this.redirectRoute) {
            this.router.navigate([this.redirectRoute]);
          }
        }

        this.dialogComponent.close();
      }, () => {
        this.dialogComponent.close();
        this.inactiveDialogOpened = false;
      });
  }

  update() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      this.buttonDisabler.disableActive();
      return false;
    }
    this.dialogComponent.lockButtons();
    const raw = this.formGroup.getRawValue();
    const data = raw;
    if (this.data.tag === 'inactive' && data.action === 'Other') {
      if (!this.formGroup.get('custom_reason').valid) {
        this.formGroup.get('custom_reason').markAsTouched();
        return;
      }
      data.action = raw.custom_reason;
    }

    if (
      this.data.tag === 'meeting' ||
      this.data.tag === 'order' ||
      this.data.tag === 'followup'
    ) {
      data.action = this.timezonePipe.transform(data.action, 'YYYY-MM-DD');
    }

    data.update = true;
    data.contact_id = this.contact_id;
    if (this.data.tag === 'followup') {
      if (raw.same_message) {
        data.future_message = raw.future_message_1;
      } else {
        console.log('HERE');
        data.future_message = [
          raw.future_message_1,
          raw.future_message_2,
          raw.future_message_3,
        ];
      }
    } else if (this.data.tag === 'meeting') {
      data.start_time = this.timezonePipe.transform(data.start_time, 'HH:mm');
      data.end_time = this.timezonePipe.transform(data.end_time, 'HH:mm');
    }

    if (['conversation', 'cycle', 'followup', 'remove', 'inactive'].indexOf(this.data.tag) !== -1 && raw.cc_to && raw.cc_to.length) {
      data.cc_to = data.cc_to.map(c => c.value).join(',');
    }

    if (this.data.tag === 'order' && data.quote === true) {
      this.contactsService.quickResponse(data, 'quote').subscribe(
        () => {
          this.dialogComponent.lockButtons();
          if (this.userData.user_type !== UserType.VSM) {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
          }
          this.dialogService.close();
          this.componentReady = false;
          if (this.redirectRoute) {
            this.router.navigate([this.redirectRoute]); console.log('redirect 7');
          }
          if (this.userData.user_type !== UserType.VSM) {
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message: 'Operation was successful!',
                    type: 'success',
                    button: {
                      text: 'dismiss',
                    },
                  },
                },
              }),
            );
          }
        },
        error => {
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: error.error,
                  type: 'error',
                  button: {
                    text: 'dismiss',
                  },
                },
              },
            }),
          );
        },
      );
    } else if (this.data.tag === 'inactive' && data.action === 'Wrong Contact') {
      this.showWrongContactDialog(data);
      return;
    } else {
      this.executeResponse(data);
    }
  }

  submit() {
    if (!this.dataReady) {
      this.buttonDisabler.unlockAll();
      this.buttonDisabler.disableActive();
      return false;
    }
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      this.buttonDisabler.unlockAll();
      this.buttonDisabler.disableActive();
      this.showLoadingSpinner = false;
      return false;
    }
    if (
      this.data.tag === 'conversation' ||
      this.data.tag === 'send-email' ||
      this.data.tag === 'custom_email_1'
    ) {
      if (!this.formGroup.valid) {
        this.formGroup.markAllAsTouched();
        this.buttonDisabler.disableActive();
        this.showLoadingSpinner = false;
        return false;
      }
    }

    if (this.data.tag === 'cycle') {
      if (!this.formGroup.get('future_message').value) {
        this.store.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: 'Please, provide message',
              type: 'error',
            },
          },
        }));
        this.buttonDisabler.unlockAll();
        this.buttonDisabler.disableActive();
        this.showLoadingSpinner = false;
        return false;
      }
    }
    this.dialogComponent.lockButtons();
    this.componentReady = false;


    const raw = this.formGroup.getRawValue();
    const data = raw;
    if (
      this.data.tag === 'meeting' ||
      this.data.tag === 'order' ||
      this.data.tag === 'followup'
    ) {
      data.action = this.timezonePipe.transform(data.action, 'YYYY-MM-DD');
      if (this.data.tag === 'meeting') {
        data.start_time = this.timezonePipe.transform(data.start_time, 'HH:mm');
        data.end_time = this.timezonePipe.transform(data.end_time, 'HH:mm');
      }
    }

    if (this.data.tag === 'inactive' && data.action === 'Other') {
      data.action = raw.custom_reason;
    }
    data.contact_id = this.contact_id;

    if (['cycle', 'meeting', 'followup', 'order', 'inactive', 'remove'].indexOf(this.data.tag) !== -1 && this.modeUpdate) {
      data.update = true;
    }

    if (this.data.tag === 'followup') {
      if (raw.same_message) {
        data.future_message = raw.future_message_1;
      } else {
        data.future_message = [
          raw.future_message_1,
          raw.future_message_2,
          raw.future_message_3,
        ];
      }
    }

    if (['conversation', 'cycle', 'followup', 'remove', 'inactive'].indexOf(this.data.tag) !== -1 && raw.cc_to && raw.cc_to.length) {
      raw.cc_to = raw.cc_to.map(c => c.value).join(',');
    }

    this.showLoadingSpinner = true;
    if (this.data.tag === 'order' && data.quote === true) {
      if (!data.amount.length) {
        if (data.product_id) {
          this.store.dispatch(openSnackbar({
            snackbarData: {
              data: {
                message: 'Please, specify the amount!',
                type: 'error'
              }
            }
          }));
          this.formGroup.get('amount').addValidators([Validators.required]);
          this.formGroup.get('amount').updateValueAndValidity();
          this.componentReady = true;
          this.showLoadingSpinner = false;
          this.buttonDisabler.unlockAll();
          this.buttonDisabler.disableActive();
          this.formGroup.markAllAsTouched();
          return;
        }
        data.amount = 0;
      }
      this.contactsService.quickResponse(data, 'quote').subscribe(
        () => {
          this.dialogComponent.lockButtons();
          this.showLoadingSpinner = false;
          if (this.userData.user_type !== UserType.VSM) {
            this.store.dispatch(updateLeftMenuCount({ data: {} }));
          }
          this.dialogService.close();
          this.componentReady = false;
          if (this.redirectRoute) {
            this.router.navigate([this.redirectRoute]); console.log('redirect 8');
          }
          if (this.userData.user_type !== UserType.VSM) {
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message: 'Operation was successful!',
                    type: 'success',
                    button: {
                      text: 'dismiss',
                    },
                  },
                },
              }),
            );
          }

          this.componentReady = false;

          if (this.redirectRoute) {
            this.router.navigate([this.redirectRoute]); console.log('redirect 9');
          }
        },
        error => {
          this.showLoadingSpinner = false;
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: error.error,
                  type: 'error',
                  button: {
                    text: 'dismiss',
                  },
                },
              },
            }),
          );
        },
      );
    } else if (this.data.tag === 'custom_email_1') {
      if (data.name) {
        delete data.name;
      }

      if (this.data.beforeSend) {
        this.data.beforeSend.subscribe(() => {
          this.contactsService.sendCustomEmail1(data).subscribe(result => {
            this.dialogComponent.lockButtons();
            if (this.data.afterSend) {
              this.data.afterSend(this.dialogComponent, result);
              return;
            }

            this.showLoadingSpinner = false;
            this.dialogService.close(result);
            this.componentReady = false;
            if (this.redirectRoute) {
              this.router.navigate([this.redirectRoute]); console.log('redirect 10');
            }
          });
        }, err => this.store.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: err.error,
              type: 'error',
            },
          },
        })));
      } else {
        this.contactsService.sendCustomEmail1(data).subscribe(result => {
          this.dialogComponent.lockButtons();
          this.showLoadingSpinner = false;
          this.dialogService.close(result);
          this.componentReady = false;
          if (this.redirectRoute) {
            this.router.navigate([this.redirectRoute]); console.log('redirect 11');
          }
        });
      }
    } else if (this.data.tag === 'enter_activity') {
      this.contactsService
        .sendActivityNote(
          this.contact_id,
          this.formGroup.get('message').value,
          this.formGroup.get('action').value,
          this.formGroup.get('subject').value,
        )
        .subscribe(response => {
          this.dialogComponent.lockButtons();
          this.showLoadingSpinner = false;
          if (this.userData.user_type !== UserType.VSM) {
            this.store.dispatch(
              openSnackbar({
                snackbarData: {
                  data: {
                    message: 'Operation was successful!',
                    type: 'success',
                    button: {
                      text: 'dismiss',
                    },
                  },
                },
              }),
            );
          }
          this.dialogService.close(response);
          this.componentReady = false;
          if (this.redirectRoute) {
            this.router.navigate([this.redirectRoute]); console.log('redirect 12');
          }
        });
    } else if (this.data.tag === 'inactive' && data.action === 'Wrong Contact') {
      this.showWrongContactDialog(data);
      return;
    } else {
      this.executeResponse(data);
    }
  }

  initUpdate() {
    this.modeUpdate = true;
    this.updateNext();
  }

  submitNext() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      this.buttonDisabler.unlockAll();
      this.buttonDisabler.disableActive();
      return;
    }

    if (this.data.tag === 'cycle') {
      if (this.stepper.selectedIndex === 0) {
        this.stepper.next();
        this.getTemplate('cycle-future');
      } else {
        this.dialogComponent.lockButtons();
        if (this.modeUpdate) {
          this.update();
        } else {
          this.showLoadingSpinner = true;
          this.submit();
        }
      }
    } else if (this.data.tag === 'enter_activity') {
      this.dialogComponent.lockButtons();
      this.showLoadingSpinner = true;
      this.submit();
      return;
    }

    if (this.data.tag === 'followup') {
      if (!this.formGroup.valid) {
        this.formGroup.markAllAsTouched();
        this.buttonDisabler.disableActive();
        return;
      }
      switch (this.stepper.selectedIndex) {
        case 0:
          this.getTemplate('followup-future');
          this.stepper.next();
          break;
        case 1:
          if (this.formGroup.controls.same_message.value) {
            this.dialogComponent.lockButtons();
            if (this.modeUpdate) {
              this.update();
            } else {
              this.showLoadingSpinner = true;
              this.submit();
            }
          } else {
            this.stepper.next();
            this.getTemplate('followup-future');
          }
          break;
        case 2:
          this.stepper.next();
          this.getTemplate('followup-future');
          break;
        case 3:
          this.dialogComponent.lockButtons();
          if (this.modeUpdate) {
            this.update();
          } else {
            this.showLoadingSpinner = true;
            this.submit();
          }
          break;
      }
    }
    this.setDialogButtons();
  }

  updateNext() {
    if (!this.formGroup.valid) {
      this.formGroup.markAllAsTouched();
      this.buttonDisabler.disableActive();
      return false;
    }
    if (this.data.tag === 'cycle') {
      if (this.stepper.selectedIndex === 0) {
        this.stepper.next();
        this.getTemplate('cycle-future');
      } else {
        this.dialogComponent.lockButtons();
        if (this.modeUpdate) {
          this.update();
        } else {
          this.submit();
        }
      }
    }

    if (this.data.tag === 'followup') {
      if (!this.formGroup.valid) {
        this.formGroup.markAllAsTouched();
        this.buttonDisabler.disableActive();
        return;
      }
      switch (this.stepper.selectedIndex) {
        case 0:
          this.stepper.next();
          this.getTemplate('followup-future');
          break;
        case 1:
          if (this.formGroup.controls.same_message.value) {
            this.dialogComponent.lockButtons();
            if (this.modeUpdate) {
              this.update();
            } else {
              this.submit();
            }
          } else {
            this.stepper.next();
            this.getTemplate('followup-future');
          }
          break;
        case 2:
          this.stepper.next();

          this.getTemplate('followup-future');
          break;
        case 3:
          this.dialogComponent.lockButtons();
          if (this.modeUpdate) {
            this.update();
          } else {
            this.submit();
          }
          break;
      }
    }

    this.setDialogButtons();
  }

  getTemplate(type) {
    this.contactsService
      .getTemplateReplies(type, this.contact_id, this.accountId)
      .subscribe(response => {
        this.initialSignature = response.replaced_content;
        this.formGroup.controls.future_message.setValue(
          this.initialSignature,
        );

        if (this.data.tag === 'followup') {
          this.initialSignature = this.initialSignature.replace(
            new RegExp(
              '<span id=[\'"]prew_mail_time[\'"]>([a-zA-Z0-9-_{} ]*)</span>',
              'gi',
            ),
            '<span id=\'prew_mail_time\'>' +
            this.timezonePipe.transform(
              this.formGroup.get('action').value,
              'MMMM',
            ) +
            '</span>',
          );

          if (this.formGroup.get('same_message').value) {
            this.formGroup.controls.future_message_1.setValue(
              this.initialSignature,
            );
          }
        } else {
          this.formGroup.controls.future_message.setValue(
            this.initialSignature,
          );
        }

        if (this.formGroup.controls.future_message_2 && !this.formGroup.controls.future_message_2.touched) {
          this.formGroup.controls.future_message_2.setValue(
            this.initialSignature,
          );
        }

        if (this.formGroup.controls.future_message_3 && !this.formGroup.controls.future_message_3.touched) {
          this.formGroup.controls.future_message_3.setValue(
            this.initialSignature,
          );
        }
      });
  }

  onPreInit(replies) {
    return {
      toolbar:
        'quick_response | undo redo | formatselect | bold italic | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist',
      plugins: 'link lists',
      indent: false,
      contextmenu: false,
      setup(editor) {
        /* Menu items are recreated when the menu is closed and opened, so we need
                   a variable to store the toggle menu item state. */
        const items = replies.map(item => {
          return {
            type: 'menuitem',
            text: item.name,
            onAction() {
              editor.insertContent(item.response);
            },
          };
        });
        editor.ui.registry.addMenuButton('quick_response', {
          text: 'Select Quick Response',
          fetch(callback) {
            callback(items);
          },
        });
      },
    };
  }

  isAllowedFilesLimitReached() {
    if (this.maxFiles) {
      return this.maxFiles <= this.files.length;
    }

    return false;
  }

  isFilesLimitReached(): boolean {
    if (!this.allowMultiple) {
      return this.files.length >= 1;
    }

    return this.isAllowedFilesLimitReached();
  }

  onClick() {
    const fileUpload = document.getElementById(
      'fileUpload',
    ) as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let index = 0; index < fileUpload.files.length; index++) {
        if (this.isFilesLimitReached()) {
          continue;
        }
        const file = fileUpload.files[index];
        this.inputForm.addControl(`file_${index}`, new FormControl(file));
        this.files.push({
          index: `file_${index}`,
          data: file,
          isValid: !this.isMaxFileSizeReached(file),
        });
      }
    };
    fileUpload.click();
  }

  cancelFile(file: FileUploadModel) {
    if (file) {
      this.removeFileFromArray(file);
    }
  }

  getAcceptedExtensions() {
    if (Array.isArray(this.accept)) {
      return this.accept.join(',');
    }

    return this.accept;
  }

  hasValidFiles(): boolean {
    return this.files.filter(file => file.isValid === true).length > 0;
  }

  isFileValid(file: File): boolean {
    let fileAllowed = true;
    if (this.accept) {
      const fileExt = file.name.split('.')[file.name.length - 1];

      if (Array.isArray(this.accept)) {
        for (const ext of this.accept) {
          if (ext.indexOf('/') !== -1 && file.type !== ext) {
            fileAllowed = false;
          } else if (
            ext.indexOf('.') !== -1 &&
            fileAllowed &&
            ext !== fileExt
          ) {
            fileAllowed = false;
          }
        }
      } else {
        if (this.accept.indexOf('/') !== -1 && file.type !== this.accept) {
          fileAllowed = false;
        } else if (
          this.accept.indexOf('.') !== -1 &&
          fileAllowed &&
          this.accept !== fileExt
        ) {
          fileAllowed = false;
        }
      }
    }

    return fileAllowed;
  }

  dropHandler(ev: DragEvent) {
    // Prevent default behavior (Prevent file from being opened)
    ev.preventDefault();

    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      for (let i = 0; i < ev.dataTransfer.items.length; i++) {
        if (this.isFilesLimitReached()) {
          continue;
        }
        // If dropped items aren't files, reject them
        if (ev.dataTransfer.items[i].kind === 'file') {
          const file = ev.dataTransfer.items[i].getAsFile();

          this.files.push({
            index: `file_${i}`,
            data: file,
            isValid: this.isFileValid(file) && !this.isMaxFileSizeReached(file),
          });
        }
      }
    } else {
      // Use DataTransfer interface to access the file(s)
      for (let i = 0; i < ev.dataTransfer.files.length; i++) {
        if (this.isFilesLimitReached()) {
          continue;
        }
        this.files.push({
          index: `file_${i}`,
          data: ev.dataTransfer.files[i],
          isValid:
            this.isFileValid(ev.dataTransfer.files[i]) &&
            !this.isMaxFileSizeReached(ev.dataTransfer.files[i]),
        });
      }
    }
  }

  refresh() {
    this.detectorRef.detectChanges();
    this.setDialogButtons();
  }

  uploadFileEvt(imgFile: any) {
    if (imgFile.target.files && imgFile.target.files[0]) {
      this.fileAttr = '';
      Array.from(imgFile.target.files).forEach((file: File) => {
        this.fileAttr += file.name + ' - ';
      });

      this.formGroup.controls.name.setValue(this.fileAttr);

      // HTML5 FileReader API
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;
      };

      this.attachments = {};
      for (const key in imgFile.target.files) {
        if (!imgFile.target.files[key]) {
          continue;
        }
        const fName = imgFile.target.files[key].name;
        if (imgFile.target.files[key] instanceof File) {
          this.getBase64(imgFile.target.files[key]).then(data => {
            this.attachments[fName] = data;
            this.formGroup.controls.attachments.setValue(this.attachments);
          });
        }
      }

      // Reset if duplicate image uploaded again
      this.fileInput.nativeElement.value = '';
    } else {
      this.fileAttr = 'Choose File';
      this.formGroup.controls.name.setValue(this.fileAttr);
      this.formGroup.controls.attachments.setValue(null);
      this.attachments = null;
    }
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  onDurationChange($event: MatRadioChange) {
    if ($event && $event.value) {
      this.initialSignature = this._replaceSignatureMonths($event.value, this.formGroup.get('message').value);
      this.formGroup.get('message').setValue(this.initialSignature);
    }
  }

  getStartDate() {
    return moment().add(1, 'day').startOf('day').toDate();
  }

  onStartDateChange($event: string, updateSignature: boolean = false) {
    // set the end time to be one hour after the selected start time
    const selectedTime = moment(this.formGroup.get('start_time').value);
    const oneHourLater = selectedTime.add(1, 'hour');
    if (updateSignature) {
      this.initialSignature = this.initialSignature.replace(new RegExp('<span id="mesd">([a-zA-Z0-9:_/{} ].+)</span>', 'gi'),
        '<span id="mesd">' +
        this.timezonePipe.transform(
          this.formGroup.get('start_time').value,
          'hh:mm a',
        ) +
        ' (' + this.userData.time_zone + ') ' +
        '</span>');
      this.initialSignature = this.initialSignature.replace(new RegExp('<span id="mess">([a-zA-Z0-9-_/{} ]*)</span>', 'gi'),
        '<span id="mess">' +
        this.timezonePipe.transform(
          this.formGroup.get('action').value,
          'MM/DD/YYYY',
        ) +
        '</span>');
    } else {
      this.formGroup.get('end_time').setValue(oneHourLater);
      this.formGroup
        .get('message')
        .setValue(
          this.formGroup
            .get('message')
            .value.replace(
            new RegExp('<span id="mesd">([a-zA-Z0-9:_/{} ].+)</span>', 'gi'),
            '<span id="mesd">' +
            this.timezonePipe.transform(
              this.formGroup.get('start_time').value,
              'hh:mm a',
            ) +
            ' (' + this.userData.time_zone + ') ' +
            '</span>',
          ),
        );
      this.formGroup
        .get('message')
        .setValue(
          this.formGroup
            .get('message')
            .value.replace(
            new RegExp('<span id="mess">([a-zA-Z0-9-_/{} ]*)</span>', 'gi'),
            '<span id="mess">' +
            this.timezonePipe.transform(
              this.formGroup.get('action').value,
              'MM/DD/YYYY',
            ) +
            '</span>',
          ),
        );
    }

  }

  onFollowUpDateChange($event: string) {
    let targetMont = this.timezonePipe.transform(
      this.formGroup.get('action').value,
      'MMMM',
    );
    const targetMonthNumber = this.timezonePipe.transform(
      this.formGroup.get('action').value,
      'M',
    );
    const nowMonth = this.timezonePipe.transform(
      new Date(),
      'M',
    );

    if (targetMonthNumber === nowMonth) {
      targetMont = 'later this month';
    } else {
      targetMont = `in ${targetMont}`;
    }
    this.formGroup
      .get('message')
      .setValue(
        this.formGroup
          .get('message')
          .value.replace(
          new RegExp(
            '<span id=[\'"]mess_f[\'"]>([a-zA-Z0-9-_/{} ]*)</span>',
            'gi',
          ),
          '<span id="mess_f">' +
          targetMont +
          '</span>',
        ),
      );
    this.formGroup
      .get('future_message_1')
      .setValue(
        this.formGroup
          .get('future_message_1')
          .value.replace(
          new RegExp(
            '<span id=[\'"]mess_f[\'"]>([a-zA-Z0-9-_/{} ]*)</span>',
            'gi',
          ),
          '<span id="mess_f">' +
          targetMont +
          '</span>',
        ),
      );
  }

  ngOnDestroy() {
    this.editorReady = false;
  }

  onInactiveReasonChange($event: MatRadioChange) {
    if (this.data.tag !== 'inactive' || !$event || !$event.value) {
      return;
    }

    if ($event.value === 'Other') {
      this.formGroup.get('custom_reason').setValidators([Validators.required]);
    } else {
      this.formGroup.get('custom_reason').setValidators([]);
      this.formGroup.get('custom_reason').updateValueAndValidity();
    }
  }

  onSelectionChange($event: StepperSelectionEvent) {
    this.componentReady = false;
    if ($event.selectedIndex !== 1) {
      return;
    }
    if (this.data.tag === 'cycle') {
      this.getTemplate('cycle-future');
    } else if (this.data.tag === 'followup') {
      this.formGroup.controls.future_message_1.setValue(
        this.initialSignature,
      );
      this.onFollowUpDateChange(null);
      this.setDialogButtons();
    }
  }

  onEditorReady() {
    this.componentReady = true;

    if(this.data.tag === 'conversation' && this.conversationEditor) {
      // Focus the editor when it's ready
      this.conversationEditor.focus();
    }
  }

  private removeFileFromArray(file: FileUploadModel) {
    const index = this.files.indexOf(file);
    if (index > -1) {
      this.files.splice(index, 1);
    }
  }

  private _numberToText(num: number | string): string {
    if (typeof num === 'string') {
      num = parseInt(num, 10);
    }
    switch (num) {
      case 1:
        return 'one';
      case 2:
        return 'two';
      case 3:
        return 'three';
      case 6:
        return 'six';
      case 9:
        return 'nine';
      case 12:
        return 'twelve';
      default:
        return num.toString();
    }
  }

  private _replaceSignatureMonths(num: string, currentTempplate?: string): string {
    const template = currentTempplate ?? this.initialSignature;
    return template.replace(
      /<span id=['"]cycle_time['"]> in [^\s]+ month[s]?<\/span>/g,
      '<span id=\'cycle_time\'> in ' +
      this._numberToText(num) +
      ' month' +
      (parseInt(num, 10) > 1 ? 's' : '') +
      '</span>',
    );
  }

  private executeResponse(data: any) {
    if (this.data.tag === 'order' && !data.amount.length) {
      if (data.product_id) {
        this.store.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: 'Please, specify the amount!',
              type: 'error'
            }
          }
        }));
        this.formGroup.get('amount').addValidators([Validators.required]);
        this.formGroup.get('amount').updateValueAndValidity();
        this.componentReady = true;
        this.showLoadingSpinner = false;
        this.buttonDisabler.unlockAll();
        this.buttonDisabler.disableActive();
        this.formGroup.markAllAsTouched();
        return;
      }
      data.amount = 0;
    }
    this.contactsService.quickResponse(data, this.data.tag).subscribe(
      () => {
        this.showLoadingSpinner = false;
        if (this.userData.user_type !== UserType.VSM) {
          this.store.dispatch(updateLeftMenuCount({ data: {} }));
        }
        this.openInactiveDialog();
        this.dialogComponent.closeDialog();

        if (this.userData.user_type !== UserType.VSM) {
          this.store.dispatch(
            openSnackbar({
              snackbarData: {
                data: {
                  message: 'Operation was successful!',
                  type: 'success',
                  button: {
                    text: 'dismiss',
                  },
                },
              },
            }),
          );
        }
      },
      error => {
        this.showLoadingSpinner = false;
        this.store.dispatch(
          openSnackbar({
            snackbarData: {
              data: {
                message: error.error,
                type: 'error',
                button: {
                  text: 'dismiss',
                },
              },
            },
          }),
        );
      },
    );
  }

  private createContact(data: any, responseData: any, dialog: DialogComponent, inDialog: DialogComponent) {
    if (this.userData.user_type === UserType.VSM) {
      data.account_id = this.accountId;
    }
    this.contactsService.createContact(data)
      .subscribe(response => {
        inDialog.close();
        dialog.closeDialog();
        this.executeResponse(responseData);
        if (this.userData.user_type !== UserType.VSM) {
          this.store.dispatch(openSnackbar({
            snackbarData: {
              data: {
                message: 'Concat was added successfully',
                type: 'success',
              },
            },
          }));
        }
      }, (error: HttpErrorResponse) => {
        this.stopCloseInactive = true;
        this.store.dispatch(openSnackbar({
          snackbarData: {
            data: {
              message: error.error,
              type: 'error',
            },
          },
        }));
        inDialog.close();
        dialog.close();
      });
  }

  private showWrongContactDialog(responseData: any) {
    this.store.dispatch(openDialog({
      dialogData: {
        content: 'Do you want to add the correct contact?',
        title: 'Add the correct contact?',
        buttons: [
          {
            text: 'No',
            color: ButtonColor.RED,
            size: ButtonSize.NORMAL,
            onClick: dialog => {
              dialog.closeDialog();
              this.executeResponse(responseData);
            },
          },
          {
            text: 'Yes',
            color: ButtonColor.GREEN,
            size: ButtonSize.NORMAL,
            onClick: (dialog) => {
              dialog.close();
              this.store.dispatch(openDialog({
                dialogData: {
                  content: InactiveAddContactComponent,
                  componentData: {
                    contactId: this.contact_id,
                    messageId: this.messageId,
                  },
                  title: 'Add Contact',
                  canClose: true,
                  onClose: (inDialog) => {
                    inDialog.close();
                    this.openInactiveDialog();
                  },
                  buttons: [
                    {
                      text: 'Add',
                      color: ButtonColor.BLUE,
                      size: ButtonSize.NORMAL,
                      onClick: inDialog => {
                        if (!inDialog.dialogForm.valid) {
                          inDialog.dialogForm.markAllAsTouched();
                          return;
                        }

                        this.store.dispatch(openDialog({
                          dialogData: {
                            closeButtonText: 'No',
                            content: 'Do you want to send email 1 to this contact?',
                            title: 'Campaign Email',
                            canClose: true,
                            onCloseButton: (dialog1) => {
                              dialog1.close();
                              const data = inDialog.dialogForm.value;
                              this.createContact(data, responseData, dialog, inDialog);
                            },
                            buttons: [
                              {
                                text: 'Yes',
                                color: ButtonColor.GREEN,
                                size: ButtonSize.NORMAL,
                                onClick: (dialog2) => {
                                  dialog2.close();
                                  const data = inDialog.dialogForm.value;
                                  this.createContact(data, responseData, dialog, inDialog);
                                },
                              },
                            ],
                          },
                        }));
                      },
                    },
                  ],
                },
              }));
            },
          },
        ],
      },
    }));
  }
}
